import Lottie from 'lottie-web';

export default class About {
  init() {
    this._initLottieAnimation();
  }

  _initLottieAnimation() {
    let containerElem = document.body.querySelector('.illiustration-animation-wrapper');

    Lottie.loadAnimation({
      container: containerElem, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: './images/arweave-animation-mountain.data.json' // the path to the animation json
    });

  }
}
